import lrsAdapter from '../../helpers/lrs_adapter'
import getAxiosInstance from '../../helpers/get_axios_instance'

class MotivoRechazoCamiones {
  static getAll () {
    const axios = getAxiosInstance()
    const promise = axios.get(`motivo_rechazo_habilitado`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }
}

export default MotivoRechazoCamiones
